import { Dialog, DialogActions, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import FormikActions from "../../commons/formik/FormikActions";
import FormikPasswordTextfield from "../../commons/formik/FormikPasswordTextfield";
import CircularLoading from "../../commons/loading/CircularLoading";
import { StyledChangePassword } from "../../styled/Layout";
import { changePasswordValidation } from "./formValidation";

const ChangePasswordForm = ({ initialValues, handleSubmit, handleClose, open, loading }) => {
  return (
    <Dialog open={open} onClose={(event, reason) => {
      if (reason === "backdropClick") return;
      handleClose();
    }}>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={handleSubmit}
        validationSchema={changePasswordValidation}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <StyledChangePassword.TitleContainer>Cambiar contraseña</StyledChangePassword.TitleContainer>
            <StyledChangePassword.DialogContent>
              {loading ? <CircularLoading /> :
                <Grid>
                  <StyledChangePassword.RowContainer item>
                    <StyledChangePassword.LockIcon />
                    <StyledChangePassword.FormField>
                      <FormikPasswordTextfield
                        name="previousPassword"
                        label="Contraseña Actual*"
                        fullWidth
                      />
                    </StyledChangePassword.FormField>
                  </StyledChangePassword.RowContainer>
                  <StyledChangePassword.RowContainer item>
                    <StyledChangePassword.LockIcon />
                    <StyledChangePassword.FormField>
                      <FormikPasswordTextfield
                        name="newPassword"
                        label="Nueva Contraseña*"
                        fullWidth
                      />
                    </StyledChangePassword.FormField>
                  </StyledChangePassword.RowContainer>
                  <StyledChangePassword.RowContainer item>
                    <StyledChangePassword.LockIcon />
                    <StyledChangePassword.FormField>
                      <FormikPasswordTextfield
                        name="repeatedNewPassword"
                        label="Confirmar contraseña*"
                        fullWidth
                      />
                    </StyledChangePassword.FormField>
                  </StyledChangePassword.RowContainer>
                </Grid>
              }
            </StyledChangePassword.DialogContent>
            <DialogActions>
              <FormikActions handleCancel={handleClose} disabled={loading} />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>

  )
}

export default ChangePasswordForm;